<template>
  <div>
    <template v-if="comments && comments.length">
      <b-card v-for="(comment, index) in comments" :key="index">
        <b-media no-body>
          <b-media-aside class="mr-75">
            <b-avatar size="38" :src="comment.user.avatar" />
          </b-media-aside>
          <b-media-body>
            <h6 class="font-weight-bolder mb-25">
              {{ comment.user.first_name + " " + comment.user.last_name }}
            </h6>
          </b-media-body>
        </b-media>
        <b-card-text class="my-2">
          {{ comment.content }}
        </b-card-text>
        <div
          class="align-items-center text-primary mt-1"
          v-if="
            comment.children &&
            comment.children.data &&
            comment.children.data.length
          "
        >
          <feather-icon icon="CornerUpLeftIcon" size="18" class="mr-50" />
          <span>پاسخ مدرس‌:</span>
          <div class="p-1">
            <div
              class="bg-light-primary text-light border-primary rounded-lg mt-50 p-2"
            >
              {{ comment.children.data[0].content }}
            </div>
          </div>
        </div>
      </b-card>
      <!-- <div class="w-100">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div> -->
    </template>
    <h6 class="section-label">نظر خود را وارد کنید</h6>
    <b-card>
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-form-group class="mb-2">
              <b-form-textarea
                name="textarea"
                rows="4"
                placeholder="متن ..."
                v-model="content"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              variant="primary"
              :disabled="content === ''"
              @click="sendComment"
            >
              <span> ارسال نظر </span>
            </b-button>
          </b-col>
          <loader :loading="loading" />
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BButton,
  BMedia,
  BMediaBody,
  BMediaAside,
  BCardText,
  BFormGroup,
  BFormTextarea,
  BLink,
  BAvatar,
} from "bootstrap-vue";
import Loader from "@core/components/loader/Loader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import qs from "qs";

export default {
  components: {
    BCard,
    BCol,
    BForm,
    BRow,
    BButton,
    BMedia,
    BMediaBody,
    BMediaAside,
    BCardText,
    BFormGroup,
    BFormTextarea,
    BLink,
    Loader,
    BAvatar,
  },
  props: {
    regardingType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      comments: [],
      loading: false,
      pagination: {},
      content: "",
    };
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  async created() {
    if (Object.keys(this.userData).length) {
      this.loading = true;
      await this.getComments();
      this.loading = false;
    }
  },
  methods: {
    async getComments() {
      try {
        const { data } = await this.$http.get("/panel/comments", {
          params: {
            filters:{
              regarding: {
              type: this.regardingType,
              id:
                this.regardingType != "session"
                  ? this.$route.params.id
                  : this.$route.params.session_id,
            },
            },
            includes: ["user", "comment", "children"],
          },
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });

        this.comments = data.data.comments;
        this.pagination = data.data.meta.pagination;
      } catch (err) {}
    },
    async sendComment() {
      this.loading = true;

      try {
        const { data } = await this.$http.post("/panel/comments", {
          regarding: {
            type: this.regardingType,
            id:
              this.regardingType == "session"
                ? this.$route.params.session_id
                : this.$route.params.id,
          },
          content: this.content,
        });
        this.content = "";
        this.$toast(
          {
            component: ToastificationContent,

            props: {
              title: "کامنت شما با موفقیت ثبت شد",
              icon: "CoffeeIcon",
              variant: "success",
            },
          },
          { position: "bottom-right", timeout: 4000 }
        );
        await this.getComments();
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>

<style></style>
